import React, { useState, useEffect } from 'react';
import {Form, Input} from "antd";
import { _APIS } from 'apis';
import request from 'request';
import { jsonParseData } from 'utils';
import SPDynamicFormRender from 'components/base/SPDynamicFormRender';

type Props = {
  enums: any;
  // Form.Item包裹后，会自动传的props
  value?: any;
  onChange?: Function;
};

const getSaasApolloConfig = (params: any) => request.get(_APIS.PRODUCT_PRICE.COMMON.CONFIG, { params });

const ServicePolicy: React.FC<Props> = (props) => {
  const [formSchema, setFormSchema] = useState<any[]>([]);

  useEffect(() => {
    getSaasApolloConfig({
      config_name: 'template_form_scheme',
      param_name: 'service_policy',
    }).then((res: any) => {
      setFormSchema(jsonParseData(res?.data?.service_policy, []))
    })
  }, [])

  return <div>
    <Form.Item
        name='name'
        label='模版名称'
        labelAlign="left"
        labelCol={{
          style: { width: '128px', marginLeft: '20px' },
        }}
        style={{
          marginBottom: '30px',
        }}
        rules={[{ required: true, message: '请输入' }]}
    >
      <Input
          style={{ width: '400px' }}
          placeholder='请输入模版名称'
          allowClear
      />
    </Form.Item>
    <SPDynamicFormRender data={formSchema} enums={props.enums} />
  </div>

};

export default ServicePolicy;
